import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

// Handles the Emergent Google OAuth return (#session_id=...)
export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const u = await googleSession(sessionId);
        toast.success("Signed in with Google", { description: u.email });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
      }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/", { replace: true });
    })();
  }, [googleSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3" data-testid="auth-callback">
      <Loader2 className="w-10 h-10 animate-spin text-primary" />
      <p className="text-gray-500 text-sm">Signing you in with Google…</p>
    </div>
  );
}
